import { useMemo } from 'react'

import { useResourceRecordsContext } from '@/shared/hooks'
import { useUserProgress } from '@/shared/hooks/useUserProgress'

import type { WalletExtractBalance, WalletMovement } from '../model/types'

type WalletRecordsContext = {
  records?: WalletMovement[]
  isLoading?: boolean
  isEmpty?: boolean
  isReachingEnd?: boolean
  size?: number
  setSize?: (size: number) => void
  config: {
    humanName: { singular: string; plural: string }
  }
}

export const useWalletExtractView = () => {
  const { wallet: progressWallet } = useUserProgress()
  const {
    records,
    isLoading,
    isEmpty,
    isReachingEnd,
    size,
    setSize,
    config
  } = useResourceRecordsContext() as WalletRecordsContext

  const wallet: WalletExtractBalance = useMemo(
    () => ({
      points: Number(progressWallet?.points ?? 0),
      coins: Number(progressWallet?.coins ?? 0)
    }),
    [progressWallet?.coins, progressWallet?.points]
  )

  const movements = (records ?? []) as WalletMovement[]

  return {
    wallet,
    movements,
    isLoading: Boolean(isLoading),
    isEmpty: Boolean(isEmpty),
    isReachingEnd: Boolean(isReachingEnd),
    size: size ?? 1,
    setSize,
    humanName: config.humanName as { singular: string; plural: string }
  }
}
